import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class SimpleEmitter {
  constructor() {
    _defineProperty(this, "listeners", new Set());
  }
  emitEvent(event) {
    this.listeners.forEach(listener => listener(event));
  }
  addEventListener(listener) {
    this.listeners.add(listener);
  }
  removeEventListener(listener) {
    this.listeners.delete(listener);
  }
}
//# sourceMappingURL=SimpleEmitter.js.map